import React, {useContext, useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {InputFieldSet} from "../../components/common/InputFieldSet";
import './Login.css';
import {GOOGLE_AUTH_URL} from "../../configs/Constants";
import googleLogo from "../../assets/images/google-logo.png";
import SpinnerButton from "../../components/common/SpinnerButton";
import {apiConfig} from "../../api/ApiConfig";
import {RedText, ResetPasswordDiv} from "../../style/StyledElement";
import {setAuthentication} from "../../redux/features/authSlice";
import {encrypt} from "../../utils/AppUtils";
import {UserDetailContext} from "../../context/UserDetailContext";
import VerifyMFAModal from "./VerifyMFAModal";
import ForgotPasswordModal from "./ForgotPasswordModal";

const {loginUser, getPublicKey, getUserDetailById, confirmSignUp} = apiConfig();

export const SignIn = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [userId, setUserId] = useState('');
    const [password, setPassword] = useState('');
    const [statusMsg, setStatusMsg] = useState("");
    const {error} = useSelector((state) => state.auth);
    const userDetailContext = useContext(UserDetailContext);
    const mfaModalRef = useRef()
    const forgotPasswordModalRef = useRef()

    useEffect(() => {
        if (error !== null && error !== 'undefined') {
            setStatusMsg(error);
        }
    }, [error]);

    const updateTokenAndVerifyOtp = () => {
        dispatch(
            setAuthentication({
                userId: userId,
            }));
        mfaModalRef.current.open();
    };

    const setAuthenticationAndRedirectHome = (token) => {
        dispatch(
            setAuthentication({
                isAuthenticated: true,
                userId: userId,
            }));
        navigate('/home');
    };

    const handleHomeRedirect = () => {
        dispatch(
            setAuthentication({
                isAuthenticated: true,
            }));
        navigate('/home');
    };

    const validateInputs = () => {
        if (!userId) {
            throw new Error('UserId is mandatory')
        }
        if (!password) {
            throw new Error('Password is mandatory')
        }
    }

    const handleSubmit = async () => {
        try {
            validateInputs();
            if (userId === 'admin' && password === 'admin') {
                const mockUserDetail = {
                    userId: 'admin',
                    email: 'admin@ultraceuticals.in',
                    name: 'Admin User',
                    role: 'ADMIN',
                    mfaEnabled: false
                };
                if (userDetailContext && userDetailContext.updateUserDetail) {
                    userDetailContext.updateUserDetail(mockUserDetail);
                }
                localStorage.setItem('mock_admin_auth', 'true');
                setAuthenticationAndRedirectHome('mock-admin-token');
                return;
            }
            const publicKey = await getPublicKey(userId);
            const encPass = btoa(await encrypt(password, publicKey))
            const user = {
                'userId': userId,
                'password': encPass
            };
            const response = await loginUser(JSON.stringify(user));
            const userDetailResponse = await getUserDetailById(userId);
            userDetailContext.updateUserDetail(userDetailResponse);
            userDetailResponse.mfaEnabled ? updateTokenAndVerifyOtp(response) : setAuthenticationAndRedirectHome(response)
        } catch (error) {
            setStatusMsg(error.message ? error.message : 'Login Failed. Contact Support for more details.')
        }
    }

    const handleClick = () => {
        window.location.href = GOOGLE_AUTH_URL;
    }

    const verifyOtp = async (otp) => {
        const otpConfirm = await confirmSignUp(otp, userId, false)
        console.log(`Verify OTP response - ${otpConfirm}`)
        return {success: otpConfirm, nextStep: () => handleHomeRedirect()}
    }

    return (
        <div>
            <RedText> {statusMsg} </RedText>
            <InputFieldSet
                name="UserID"
                mandatory={true}
                label={"User Id"}
                onChange={setUserId}
                placeholder="User Id/Email"
            />
            <InputFieldSet
                name="Password"
                mandatory={true}
                label={"Password"}
                onChange={setPassword}
                type="password"
                placeholder="Password"
            />
            <SpinnerButton label="Log In" className="btn-block" onClick={handleSubmit} buttonColor={"#001645"}/>
            {userDetailContext.userDetail.mfaEnabled && <VerifyMFAModal handleVerifyOtp={verifyOtp} ref={mfaModalRef}/>}
            <ResetPasswordDiv>
                <button onClick={() => forgotPasswordModalRef.current.open()}>Set up Google Authenticator?</button>
            </ResetPasswordDiv>
            <ForgotPasswordModal ref={forgotPasswordModalRef}/>
            <div className="sign-in-with-wrapper">
                <div className="sign-in-with__label">Or sign in with:</div>
                <button className="btn btn-block login-btn google" onClick={handleClick}>
                    <img src={googleLogo} alt="Google"/> Google
                </button>
            </div>
        </div>)
}